import { Grid,Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import SearchBar from "../../../../Components/SearchBar/SearchBar";
import AddButton from "../../../../Components/AddButton/AddButton";
import AddNewTPA from "./AddNewTPA";
import { genericFetchData } from "../../../../Services/Service";
import { getUserCode } from "../../../../Storage/Datastore";
import { checkPermission } from "../../../../Utils/Permissions";
import TPATable from "./TPATable/TPATable";

const TPA = () => {
  const [isEdit, setisEdit] = useState(false);
  const [modal, setModal] = useState({ isOpen: false });
  const [tpa, setTPAs] = useState([]);
  const [insurances, setInsurances] = useState([]);
  const [show, setshow] = useState(0);
  const [filter, setFilter] = useState({ keyword: "" });


  const saveTPA = async (postData, id) => {
    console.log("postData", postData);
    if (id) {
      postData.id = id;
    }
    const response = await genericFetchData(`/tpa/save`, "POST", postData);
    const status = response.status;
    if (status == 200) {
      // getInsuranceData();
      alert("saved");
      refreshTPA();
    }
    console.log("=======error", status);
  };

  const refreshTPA = () => {
    getInsurances([0]);
    getFilteredTpas(filter);
    setshow(0);
  };

  const approveData = {
    type: "APPROVE",
    handleApprove: saveTPA,
    buttons: [
      { id: 1, buttonName: "No" },
      { id: 2, buttonName: "Yes" },
    ],
  };

  const addTPA = {
    type: "TPA",
    save: saveTPA,
    buttons: [
      { id: 1, buttonName: "Cancel" },
      { id: 2, buttonName: "Add" },
    ],
  };

  const handleOpen = (data) => {
    setModal({ isOpen: true, data: data });
  };

  const handleApprovePopUpOpen = (data, checked, id) => (e) => {
    data.approve = e.target.checked;
    data.id = id;
    data.checked = checked;
    setModal({ isOpen: true, data: data });
  };

  const getInsurances = async (id) => {
    const departmentId = id ? id : tpa[0]?.id;
    const response = await genericFetchData(`/tpa/${departmentId}`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      setInsurances(responseData.insurances);
    } else {
      console.log("=======error", responseData);
    }
  };

  const getFilteredTpas = async (postData) => {
    const response = await genericFetchData(`/tpa/filtered`, "POST", postData);
    const status = response.status;
    if (status === 200) {
      const responseData = await response.json();
      setTPAs(responseData?.tpaResponses);
      getInsurances(responseData?.tpaResponses[0]?.id);
    }
  };

  const deleteCategory = async (id) => {
    const userCode = getUserCode();
    const response = await genericFetchData(
      `/tpa/delete/${id}?userCode=${userCode}`,
      "DELETE"
    );
    const status = response.status;
    if (status == 200 || status == 500) {
      refreshTPA();
    }
  };

  useEffect(() => {
    getFilteredTpas(filter);
  }, [filter]);

  return (
    <>
      <Grid
        lg={12}
        sx={{
          width: "100%",
          height: "88vh",
          padding: "0px 25px",
        }}>
        <AddNewTPA
          setOpenModal={setModal}
          openModal={modal.isOpen}
          data={modal}
        />
        <Grid container lg={12} justifyContent={"flex-end"} item>
          {checkPermission("KARE_DB_INSURANCE_EDIT") && (
            <AddButton
              style={{ position: "absolute", top: "34px", paddingX: "10px" }}
              labelName={"Add New TPA"}
              onClick={() => {
                handleOpen(addTPA);
              }}
              width={"fit-content"}
              viewHeight={"40px"}
              borderRadius={"50px"}
            />
          )}
        </Grid>
        <Grid lg={6} justifyContent="space-between" mb={5} item container>
          <Grid item width={100}>
            {/* <Typography>Category</Typography> */}
          </Grid>

          <Grid item lg={4.5} width={"100%"}>
            {/* <SearchBar
              placeHolder={"Search Category"}
              onChagevalue={(e) =>
                setFilter((s) => ({ keyword: e.target.value }))
              }
              width="100%"
            /> */}
          </Grid>
        </Grid>
        <Grid
          container
          style={{ position: "sticky" }}
          height={"75vh"}
          item
          md={12}>
          <TPATable tpaData={tpa} />
        </Grid>
      </Grid>
    </>
  );
};

export default memo(TPA);
